<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard v-if="!loadingInitialValue">
          <PropertyAdditionalChargeDetails
            @submitted="submitted"
            :editMode="true"
            :loading="loading"
            :propertyAdditionalChargeDetails="propertyAdditionalCharge"
          ></PropertyAdditionalChargeDetails>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";
import PropertyAdditionalChargeDetails from "@/components/settings/pricing/PropertyAdditionalChargeDetails.vue";
import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import qs from "qs";

export default {
  name: "property_additional_charge",
  components: {
    SimpleCard,
    PropertyAdditionalChargeDetails
  },
  data: function() {
    return {
      loading: false,
      loadingInitialValue: true,
      propertyAdditionalCharge: null,
    };
  },
  mounted: async function() {
    this.getPropertyAdditionalCharge();
  },
  methods: {
    success: function(data) {
      this.$router.push("/settings/pricing/property_additional_charges/" + data.property_additional_charge.id);
    },
    failed: function(data) {
      alert("Request Failed with error: " + data.message);
    },
    getPropertyAdditionalCharge: async function() {

      var url = `${this.$store.state.apiUrl}/property_additional_charge/get/${
        this.$route.params.id
      }`;

      let response = await axios.get(url, {
        params: {}
      });

      this.propertyAdditionalCharge = response.data.property_additional_charge;
      this.loadingInitialValue = false;
    },
    submitted: function(p) {
      console.log("Form Submitted");

      this.loading = true;

      p = JSON.parse(JSON.stringify(p))
      p.amount = (p.amount * 100)

      var url = `${this.$store.state.apiUrl}/property_additional_charge/update/${this.$route.params.id}`;

      var completed = this.success;

      axios({
        url: url,
        method: "POST",
        data: p,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      })
        .then(function(res) {
          if (res.data.error == "no_error") {
            completed(res.data);
          } else {
            failed(res.data.error);
          }
        })
        .catch(function(err) {
          failed("internal_server_error");
          console.error(err);
        });
    }
  }
};
</script>
